<template>
  <div class="table">
    <div class="table-title">{{ $t('aftersales.contactus') }}</div>
    <div class="list">
      <div class="list-card">
        <el-card class="list-item" @click.native="chatOpen">
          <img class="icon" :src="`${$g.imgPrefix}/img/aftersales/message.svg`">
          <!-- 在线聊天-->
          <div class="list-title">{{$t('aftersales.onlinechat')}}</div>
          <!-- 7*24服务-->
          <div class="list-text">{{$t('home.onlinesupport')}}</div>
        </el-card>
        <el-card v-if="false" class="list-item">
          <img class="icon" :src="`${$g.imgPrefix}/img/aftersales/question.svg`">
          <div class="list-title">帮助中心</div>
          <div class="list-text">查看帮助文章</div>
        </el-card>
      </div>

      <!--      <div class="list-title">{{$t('aftersales.workorder')}}</div>-->
      <div class="list-top">
        <!-- 售后支持-->
        <div class="list-top-title">{{$t('subscribe.aftersales')}}</div>
        <!-- 我们将会在您提交工单之后尽快解决-->
        <div class="list-top-desc">{{$t('aftersales.resolveworkorder')}}</div>
        <div class="list-header-btn">
          <el-button type="primary" class="table-header-btn" @click="createWorkOrder">{{$t('aftersales.create')}}
          </el-button>
          <!--        <el-button type="primary" class="table-header-btn" @click="chatOpen">Contact Me</el-button>-->
        </div>
      </div>

      <template v-if="tableList&&tableList.length>0">
        <el-table
            :data="tableList"
            class="w-100">
          <el-table-column
              width="140px"
              prop="workorderno"
              :label="$t('aftersales.workorderno')">
          </el-table-column>
          <el-table-column
              prop="ticket.goodsSpu.goodsname"
              :label="$t('aftersales.product')">
          </el-table-column>
          <el-table-column
              :label="$t('aftersales.status')">
            <template v-slot="scope">
              {{ filterObj(statusOptions, 'value', scope.row.status).label }}
            </template>
          </el-table-column>
          <el-table-column
              :label="$t('aftersales.type')">
            <template v-slot="scope">
              {{ filterObj(workType, 'id', scope.row.typeid).typename }}
            </template>
          </el-table-column>
          <el-table-column
              prop="ticket.loginemail"
              :label="$t('aftersales.ticket')">
          </el-table-column>
          <el-table-column
              prop="createTime"
              :label="$t('aftersales.createtime')">
          </el-table-column>
          <el-table-column
              prop="reply"
              :label="$t('aftersales.reply')">
          </el-table-column>
          <el-table-column
              width="130px"
              :label="$t('aftersales.operate')">
            <template v-slot="scope">
              <!-- Revoke-->
              <el-button type="text" icon="el-icon-error" :disabled="scope.row.status!='1'" @click="handleCal(scope.row)">
                {{$t('aftersales.revoke')}}
              </el-button>
              <!-- Content-->
              <el-button type="text" class="ml-0" icon="el-icon-document" @click="handleContent(scope.row)">
                {{$t('aftersales.content')}}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="large tr mt-2">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
          </el-pagination>
        </div>
        <div class="small tr mt-2">
          <el-pagination
              @current-change="handleCurrentChange"
              :current-page="page"
              small
              layout="prev, pager, next"
              :total="total">
          </el-pagination>
        </div>
      </template>
      <!-- 无工单-->
      <div v-else class="list-empty">
        <img class="w-100" :src="`${$g.imgPrefix}/img/common/no-result.webp`">
        <div class="list-empty-text">{{$t('aftersales.noworkorder')}}</div>
      </div>
    </div>


    <div>

      <!--      <el-data-table ref="table" v-bind="tableConfig" :columns="columns">-->
      <!--      </el-data-table>-->

      <el-dialog
          :width="screenWidth<992?'85%':'600px'"
          :visible.sync="dialogFormVisible"
          :close-on-press-escape="false"
          :close-on-click-modal="false"
          :before-close="closeDialog">
        <div class="wishtext">{{ $t('aftersales.createjob') }}</div>
        <div class="title">
          <div class="titletxt">{{ $t('aftersales.submittinworkorder') }}</div>
        </div>
        <el-form :model="form" :rules="rules" ref="ruleUser">
          <el-row type="flex" :gutter="40">
            <el-col :lg="12" :md="24" :sm="24" :xs="24">
              <el-form-item prop='ticketid'>
                <el-select v-model="form.ticketid" :placeholder="$t('aftersales.subscriptionaccount')">
                  <el-option
                      v-for="item in ticketList"
                      :key="item.id"
                      :label="item.loginemail"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :lg="12" :md="24" :sm="24" :xs="24">
              <el-form-item prop='typeid'>
                <el-select v-model="form.typeid" :placeholder="$t('aftersales.problemtype')">
                  <el-option
                      v-for="item in workType"
                      :key="item.id"
                      :label="item.typename"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop='content' class="mb-0">
                <editor :init="editorInit" v-model="form.content"/>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <!-- <el-button type="primary" @click="submitUser">Submit</el-button> -->
          <el-button type="primary" class="green-btn" @click="submitUser">{{ $t('subscribe.submit') }}</el-button>
        </div>
      </el-dialog>


      <el-dialog
          :width="screenWidth<992?'85%':'600px'"
          customClass="customWidth"
          :visible.sync="dialogFormVisibleContent"
          :close-on-press-escape="false"
          :close-on-click-modal="false"
          :before-close="closeDialogContent">
        <div class="justify-center">
          <!-- <span class="wishtext">Work order Content</span> -->
          <!--                    <span class="wishtext">제출된 질문 목록</span>-->
          <span class="wishtext">{{ $t('aftersales.workordercontent') }}</span>
        </div>
        <div class="justify-center" v-html="content" style="margin-top: 20px;">

        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script defer src="<%= BASE_URL %>static/tinymce/tinymce.min.js"></script>
<script>
import {
  uploadFile,
  insertWorkorder,
  getWordertypeAll,
  getTicketListByUserId,
  updateWorkorder,
  getWorkOrderList
} from "@/request/requests";
import {
  filterObj,
  startLoading,
  MessageError,
  MessageSuccess,
  getUserInfo
} from "@/util/util"
import Editor from '@tinymce/tinymce-vue'

export default {
  components: {
    Editor
  },
  name: "aftersales",
  data() {
    const statusOptions = [
      {
        value: "1",
        // label:"To be processed"
        // label:"처리 예정"
        label: this.$t('aftersales.tobeprocessed'),
      },
      {
        value: "2",
        // label:"processed"
        // label:"해결"
        label: this.$t('aftersales.processed'),
      },
      {
        value: "3",
        // label:"Revoked"
        // label:"취소됨"
        label: this.$t('aftersales.revoked'),
      },
    ]
    const columns = [
      // {prop: 'workorderno', label: 'Work order No'},
      // {prop: 'workorderno', label: '작업 주문 번호'},
      {prop: 'workorderno', label: this.$t('aftersales.workorderno')},
      // {prop: 'ticket.carname', label: 'Product'},
      // {prop: 'ticket.carname', label: '제품'},
      {prop: 'ticket.carname', label: this.$t('aftersales.product')},
      // {prop: 'status', label: 'status',formatter: row => this.statusState(row)},
      // {prop: 'status', label: '상태',formatter: row => this.statusState(row)},
      {prop: 'status', label: this.$t('aftersales.status'), formatter: row => this.statusState(row)},
      // {prop: 'typeid', label: 'type',formatter: row => this.typeState(row)},
      // {prop: 'typeid', label: '유형',formatter: row => this.typeState(row)},
      {prop: 'typeid', label: this.$t('aftersales.type'), formatter: row => this.typeState(row)},
      // {prop: 'ticket.loginemail', label: 'ticket'},
      // {prop: 'ticket.loginemail', label: '티켓'},
      {prop: 'ticket.loginemail', label: this.$t('aftersales.ticket')},
      // {prop: 'createTime', label: 'createTime'},
      // {prop: 'createTime', label: '생성시간'},
      {prop: 'createTime', label: this.$t('aftersales.createtime')},
      {prop: 'reply', label: this.$t('aftersales.reply')},

    ]
    return {
      screenWidth: null,
      tableList: [],
      page: 1,
      size: 10,
      total: 0,
      userinfo: "",
      workType: [],
      ticketList: [],
      columns,
      statusOptions,
      tableConfig: {
        url: '',
        dataPath: 'data.list',
        totalPath: 'data.total',
        paginationSize: 10,
        extraButtons: [
          {
            type: 'primary',
            text: 'Revoke',
            icon: 'el-icon-error',
            disabled: (row) => {
              if (row.status == '1') {
                return false
              } else {
                return true
              }
            },
            atClick: async row => {
              this.handleCal(row)
              return false
            },
          },
          {
            type: 'primary',
            text: 'Content',
            icon: 'el-icon-document',
            atClick: async row => {
              this.handleContent(row)
              return false
            },
          },
        ],
        headerButtons: [
          {
            type: 'primary',
            // text: 'Create',
            text: this.$t('aftersales.create'),
            atClick: async row => {
              this.createWorkOrder(row)
              return false
            },
          },
          {
            type: 'primary',
            text: 'Contact me',
            // text: this.$t('aftersales.create'),
            atClick: () => {
              $crisp.push(['do', 'chat:open']);
            },
          },
        ],
        hasDelete: false,
        hasEdit: false,
        hasOperation: true,
        hasNew: false,
        operationAttrs: {
          width: '100px',
          fixed: 'right',
        },
      },
      form: this.initForm(),
      dialogFormVisible: false,
      dialogFormVisibleContent: false,
      content: "",
      rules: {
        ticketid: [
          {
            required: true,
            message: this.$t('home.pleasechoose') + ' ' + this.$t('aftersales.subscriptionaccount'),
            trigger: 'blur'
          },],
        // {required: true, message: '구독 계정을 선택하세요.', trigger: 'blur'},],
        typeid: [
          {required: true, message: this.$t('home.pleasechoose') + ' ' + this.$t('aftersales.type'), trigger: 'blur'},],
        // {required: true, message: '질문 유형을 선택하세요.', trigger: 'blur'},],
        content: [
          // {required: true, message: 'Please enter the work order content.', trigger: 'blur'},],
          // {required: true, message: '작업 주문 내용을 입력하십시오.', trigger: 'blur'},],
          {
            required: true,
            message: this.$t('home.pleaseenter') + ' ' + this.$t('aftersales.workordercontent'),
            trigger: 'blur'
          },],

      },
      editorInit: {
        // language: 'zh_CN',
        language: 'ko-KR',
        convert_urls: false,
        height: 300,
        plugins: ['advlist anchor autolink autosave code codesample colorpicker colorpicker contextmenu directionality emoticons fullscreen hr image imagetools importcss insertdatetime link lists media nonbreaking noneditable pagebreak paste preview print save searchreplace spellchecker tabfocus table template textcolor textpattern visualblocks visualchars wordcount kityformula-editor'],
        toolbar: ['bold italic underline strikethrough alignleft aligncenter alignright outdent indent  blockquote undo redo removeformat subscript superscript code codesample',
          'hr numlist link image charmap preview anchor pagebreak insertdatetime media table emoticons forecolor backcolor fullscreen',
          'fontselect formatselect fontsizeselect kityformula-editor'],
        images_upload_handler: function (blobInfo, success, failure) {
          const formData = new FormData()
          formData.append('file', blobInfo.blob())
          uploadFile(formData).then(res => {
            success(res.data)
          }).catch(() => {
            failure('Upload failed, please upload again')
          })
        }
      }
    }
  },
  methods: {
    filterObj,
    async getTableList() {
      let loading = startLoading();
      let params = {
        userid: this.userinfo.id,
        size: this.size,
        page: this.page,
      }
      let res = await getWorkOrderList(this.$qs.stringify(params))
      if (res.status === "200") {
        this.tableList = res.data?.list;
        this.total = res.data?.total;
      } else {
        MessageError(res.msg);
      }
      loading.close();
    },
    calcWidth() {
      this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      //this.screenWidth = window.screen.width;
      this.$forceUpdate();
    },
    handleSizeChange(val) {
      this.size = val;
      this.page = 1;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getTableList();
    },
    chatOpen() {
      window.$crisp.push(['do', 'chat:open']);
    },
    closeDialogContent() {
      this.dialogFormVisibleContent = false
    },
    statusState(row) {
      let data
      this.statusOptions.forEach(r => {
        if (r.value == row.status) {
          data = r.label
        }
      })
      return data
    },
    typeState(row) {
      let data
      this.workType.forEach(r => {
        if (r.id == row.typeid) {
          data = r.typename
        }
      })
      return data
    },
    initForm() {
      return {
        id: "", // 序号
        userid: "", // 用户id
        workorderno: "", // 工单号
        ticketid: "", // 车票id
        typeid: "", // 类型id
        content: "", // 工单内容
        status: "", // 状态
        reply: "", // 处理回复
        createTime: "", // 创建时间
        updateTime: "", // 更新时间
        ext1: "", // 扩展字段
        ext2: "", // 扩展字段
        ext3: "", // 扩展字段
        ext4: "", // 扩展字段
      }
    },
    createWorkOrder() {
      this.dialogFormVisible = true
    },
    closeDialog() {
      this.dialogFormVisible = false
      this.form = this.initForm();
      this.$refs.ruleUser.clearValidate();
    },
    async submitUser() {
      this.$refs.ruleUser.validate((valid) => {
        if (valid) {
          this.operatorUser()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async operatorUser() {
      let res = await insertWorkorder(this.form)
      if (res.status == "200") {
        MessageSuccess(res.msg)
        this.closeDialog()
      } else {
        MessageError(res.msg)
      }
      this.getTableList();
    },
    handleContent(row) {
      this.content = row.content
      this.dialogFormVisibleContent = true
    },
    async handleCal(row) {
      this.form = row
      this.form.status = '3'
      let res = await updateWorkorder(this.form)
      if (res.status == "200") {
        MessageSuccess(res.msg)
        this.closeDialog()
      } else {
        MessageError(res.msg)
      }
    },
    async getWordertypeAllInfo() {
      let res = await getWordertypeAll()
      if (res.status == "200") {
        this.workType = res.data
      } else {
        MessageError(res.msg)
      }
    },
    async getTicketListByUserIdInfo() {
      let res = await getTicketListByUserId()
      if (res.status == "200") {
        this.ticketList = res.data
      } else {
        MessageError(res.msg)
      }
    }
  },
  mounted() {
    let userInfo = getUserInfo()
    if (userInfo) {
      this.userinfo = JSON.parse(userInfo)
      this.getWordertypeAllInfo()
      this.getTicketListByUserIdInfo()
      // this.tableConfig.url = "workorder/list?userid=" + this.userinfo.id
      // this.tableConfig.axiosConfig = {
      //   headers: {
      //     'Authorization': 'X-KILOGOD-AUTHORIZATION ' + this.$cookies.get('token'),
      //   }
      // }
      this.getTableList();
    }
    this.$nextTick(() => {
      this.calcWidth();
      window.addEventListener("resize", this.calcWidth);
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcWidth);
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/table.scss";
::v-deep .el-dialog{
  margin-top:6vh!important;
  &__body {
    height: calc(100vh - 300px);
    overflow-y: auto;
  }
}
.list-header-btn{
  width: 54%;
  margin:0 auto;
  text-align: right;
}
.list-top{
  &-title{
    width:100%;
    text-align: center;
    font-size: 32px;
    color:#000;
    font-weight: bold;
  }
  &-desc{
    letter-spacing: 0.5px;
    color: #a3a2a2;
    font-size: 14px;
    font-weight: 500;
    margin: 24px 0;
    text-align: center;
  }
}
.list {
  &-empty{
    width:220px;
    margin:0 auto;
    text-align: center;
    &-text{
      margin-top:30px;
      color:#333232cc;
      font-size:16px;
      @media (max-width:576px) {
        margin-top:10px;
        font-size:14px;
      }
    }
  }
  &-card {
    display: flex;
    justify-content: center;
    margin-bottom: 69px;
    @media (max-width:576px) {
      margin-bottom:30px
    }
  }

  &-item {
    width: 250px;
    cursor: pointer;
    background-color: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 24px #00000014;
    color: #333232cc;
    padding: 24px 20px;

    &:not(:last-child) {
      margin-right: 24px;
    }

  }

  ::v-deep .el-card {
    &__body {
      padding: 0 !important;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  &-title {
    color: #333232;
    font-size: 16px !important;
    margin-bottom: 10px !important;
  }

  .icon {
    width: 40px;
    margin-bottom: 10px;
    animation: icon 2s infinite;
  }

  @keyframes icon {
    0%, 100% {
      transform: rotate(10deg);
    }
    50% {
      transform: rotate(-20deg);
    }
  }

}

.table-header-btn {
  padding: 17px 70px !important;
}


.wishtext {
  font-weight: bolder;
  font-size: 22px;
  color: black;
  text-align: center;
  @media(max-width: 576.98px) {
    font-size: 18px;
    margin-bottom: 22px;
  }
}

.title {
  margin-bottom: 30px !important;
}

.titletxt {
  width: 100%;
  font-size: 14px;
  font-family: Source Han Sans CN-Norm;
  font-weight: normal;
}

::v-deep .el-textarea__inner {
  background: #F2F2F2;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  border: 0;
  border-radius: 10px;
}
</style>

